import React from 'react';
import i18next from "../../i18n";
export const errorMessage = (value, key) => value && <div className="help-block">{i18next.t(key)}</div>;
export const isRequiredMessage = (value) => errorMessage(value, 'requiredField');
export const isBadFormatMessage = (value) => errorMessage(value, 'badFieldFormat');